import { dataMagnet } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMagnet = /*#__PURE__*/createIcon(dataMagnet)
export default IconMagnet
